import { render, staticRenderFns } from "./master-admin.vue?vue&type=template&id=6c0d154a&scoped=true&"
import script from "./master-admin.vue?vue&type=script&lang=js&"
export * from "./master-admin.vue?vue&type=script&lang=js&"
import style0 from "./master-admin.vue?vue&type=style&index=0&id=6c0d154a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d154a",
  null
  
)

export default component.exports